import {FC} from 'react';
import {useSetRecoilState} from 'recoil';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import {currentDeviceModelState, deviceModelControlModeState} from '../../../../store/deviceModels/atoms';

import {IDeviceModel} from '../../../../shared/types/deviceModels.types';

interface IDeviceModelRow {
  row: IDeviceModel;
  setOpen: (bool: boolean) => void;
}

export const DeviceModelRow: FC<IDeviceModelRow> = ({row, setOpen}) => {
  const setCurrent = useSetRecoilState(currentDeviceModelState);
  const setModeOfControl = useSetRecoilState(deviceModelControlModeState);

  const toEditDeviceModel = () => {
    setCurrent(row);
    setOpen(true);
    setModeOfControl('EDIT');
  };

  return (
    <TableRow
      onDoubleClick={toEditDeviceModel}
      sx={{
        cursor: 'pointer',
      }}
      hover
    >
      <TableCell scope="row" align="left">
        {row.model}
      </TableCell>
      <TableCell align="left">{row.years}</TableCell>
      <TableCell align="left">{row.fazesCount}</TableCell>
      <TableCell align="left">{row.tariffsCount}</TableCell>
    </TableRow>
  );
};
